import { Entry } from '../Entry'

export function Entry20230221() {
  return (
    <Entry title="21/02/2023 - v3.3.6">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/13717/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
